/* eslint-disable no-process-env */

import { Config } from './types';

const config: Config = {
    env: process.env.ENVIRONMENT || process.env.NODE_ENV!,
    apiUrl: process.env.API_URL ?? '',
    partnerHubUrl: process.env.PARTNER_HUB ?? '',
    socketHost: process.env.SOCKET_HOST ?? '',
    fcmVapidKey: process.env.FCM_VAPID_KEY ?? '',
    jetFmObfuscationKey: process.env.JET_FM_OBFUSCATION_KEY ?? '',
    release: process.env.RELEASE ?? 'unknown',
    codePushKeyIos: '',
    codePushKeyAndroid: '',
    keycloakUrl: {
        default: process.env.KEYCLOAK_URL ?? '',
        internal: process.env.KEYCLOAK_INTERNAL_URL ?? '',
        uk: process.env.KEYCLOAK_URL_UK ?? '',
        es: process.env.KEYCLOAK_URL_ES ?? '',
        ie: process.env.KEYCLOAK_URL_IE ?? '',
        it: process.env.KEYCLOAK_URL_IT ?? '',
        au: process.env.KEYCLOAK_URL_AU ?? '',
        nz: process.env.KEYCLOAK_URL_NZ ?? ''
    },
    keycloakRedirectAppUrl: ''
};

export default config;
